import { readonly, ref } from 'vue';

/** 全站唯一滚动状态，避免多处重复监听 scroll/wheel */
const isScrolling = ref(false);

let scrollEndTimer = 0;
let listenerCount = 0;

function markScrolling() {
  if (!isScrolling.value) {
    isScrolling.value = true;
    document.documentElement.classList.add('is-scrolling');
  }
  clearTimeout(scrollEndTimer);
  scrollEndTimer = window.setTimeout(() => {
    isScrolling.value = false;
    document.documentElement.classList.remove('is-scrolling');
  }, 120);
}

function attachListeners() {
  window.addEventListener('scroll', markScrolling, { passive: true });
  window.addEventListener('wheel', markScrolling, { passive: true });
}

function detachListeners() {
  window.removeEventListener('scroll', markScrolling);
  window.removeEventListener('wheel', markScrolling);
  clearTimeout(scrollEndTimer);
  isScrolling.value = false;
  document.documentElement.classList.remove('is-scrolling');
}

export function useScrollActivity() {
  if (listenerCount === 0) attachListeners();
  listenerCount += 1;

  const release = () => {
    listenerCount = Math.max(0, listenerCount - 1);
    if (listenerCount === 0) detachListeners();
  };

  return { isScrolling: readonly(isScrolling), release };
}
